import { Helpers } from '../../helpers';
import { ITeamRole } from '../../interfaces/iteam-role';
import { DefaultProjectTeam } from '../default-project-team';
import { ProjectTeamMemberAssignment } from '../project-team-member-assignment';

export class TeamRoleBase {
  TeamRoleId: number;
  Name: string;
  SortOrder: number | null;
  HoverTextDescription: string | null;
  IsPrimaryRole: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  //ProjectTeamMemberAssignments_TeamRole?: Array<ProjectTeamMemberAssignment> | null;
  DefaultProjectTeams_ProgramManagerTeamRole?: Array<DefaultProjectTeam> | null;
  DefaultProjectTeams_ProjectControlAnalystTeamRole?: Array<DefaultProjectTeam> | null;
  DefaultProjectTeams_ProjectEngineerTeamRole?: Array<DefaultProjectTeam> | null;
  DefaultProjectTeams_ProjectManagerTeamRole?: Array<DefaultProjectTeam> | null;
  DefaultProjectTeams_ProjectTechTeamRole?: Array<DefaultProjectTeam> | null;

  constructor(item?: ITeamRole) {
    if (item) {

      this.TeamRoleId = item.TeamRoleId;
      this.Name = item.Name;
      this.SortOrder = item.SortOrder;
      this.HoverTextDescription = item.HoverTextDescription;
      this.IsPrimaryRole = item.IsPrimaryRole;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      //this.ProjectTeamMemberAssignments_TeamRole = Helpers.createClassArray(ProjectTeamMemberAssignment, item.ProjectTeamMemberAssignments_TeamRole);
      this.DefaultProjectTeams_ProgramManagerTeamRole = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProgramManagerTeamRole);
      this.DefaultProjectTeams_ProjectControlAnalystTeamRole = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProjectControlAnalystTeamRole);
      this.DefaultProjectTeams_ProjectEngineerTeamRole = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProjectEngineerTeamRole);
      this.DefaultProjectTeams_ProjectManagerTeamRole = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProjectManagerTeamRole);
      this.DefaultProjectTeams_ProjectTechTeamRole = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProjectTechTeamRole);
    }
  }
}